import { ActionTree, GetterTree, MutationTree } from "vuex";
import { CouponStoreType, CouponType } from "@/types/CouponTypes";

const state: CouponStoreType = {
  coupon: {} as CouponType,
  coupons: [],
  lockCoupons: [
    "ec775675-6ca8-4404-a89d-5830ae60fb6c",
    "590b42f9-02cd-4269-b9d3-d35c4a7c0e5c",
  ],
};

const getters: GetterTree<CouponStoreType, any> = {
  coupon: (state) => state.coupon,
  coupons: (state) => state.coupons,
  lockCoupons: (state) => state.lockCoupons,
};

const mutations: MutationTree<CouponStoreType> = {
  setCoupons(state, coupons) {
    state.coupons = coupons;
  },
  setCoupon(state, coupon) {
    state.coupon = coupon;
  },
  setLockCoupons(state, lockCoupons) {
    state.lockCoupons = lockCoupons;
  },
};

const actions: ActionTree<CouponStoreType, any> = {
  async setCoupons({ commit, state }, newCoupon: CouponType) {
    const searchCoupon = state.coupons.find(
      (coupon) => coupon.planId === newCoupon.planId
    );

    if (!searchCoupon) {
      commit("setCoupons", [...state.coupons, newCoupon]);
    }
  },
  async updateCoupons({ commit, state }, newCoupon: CouponType) {
    const mountedCoupons = state.coupons.reduce((acc, coupon) => {
      if (coupon.planId === newCoupon.planId) {
        acc.push(newCoupon);
      } else {
        acc.push(coupon);
      }
      return acc;
    }, [] as CouponType[]);
    commit("setCoupon", newCoupon);
    commit("setCoupons", mountedCoupons);
  },
  async setCoupon({ commit }, coupon: CouponType) {
    commit("setCoupon", coupon);
    const mountCoupons = state.coupons.map((couponCurrent) => {
      if (coupon.planId === couponCurrent.planId) {
        return coupon;
      }
      return couponCurrent;
    }, [] as CouponType[]);
    commit("setCoupons", mountCoupons);
  },
  async setLockCoupons({ commit }, lockCoupons: string[]) {
    commit("setLockCoupons", lockCoupons);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
